import {ref} from 'vue';
import {IndexedDB} from '@/funcoes/indexedDB';
import Query from "devextreme/data/query";

export default class PainelModules {

    constructor(app: any) {
        this._app = app;
    }

    _app = null;

    //#region V A R I A V E I S
    paletasCores = ref([]);

    carregouDoBanco = ref(false);

    exibirGaleriaObjetos = ref({
        visivel: false,
        salvar: false
    })

    content = ref({
        id: 'vdr-painel', //se mudar aqui, mudar tb no slyte do painel.vue, afeta tambem no arquivo "lista_objetos2.vue",
        tamanho: {
            original: null,
            atual: null
        }
    })

    //variaveis de eventos
    contentResized = ref({
        tamanho: null,
        handler: 0
    });

    tabelaAtualizaFontesDados = ref({
        handler: 0,
        tabela: ''
    });
    atualizaDados = ref({
        handler: 0
    });

    painelResized = ref({
        tamanho: null,
        handler: 0
    });

    painelResizedTablet = ref({
        tamanho: null,
        handler: 0
    });

    painelResizedWidget = ref({
        tamanho: null,
        handler: 0
    });

    painelResizedMobile = ref({
        tamanho: null,
        handler: 0
    });

    painelCopyObjects = ref({
        handler: 0
    });

    painelCutObjects = ref({
        handler: 0
    });

    painelCopyCutCancelObjects = ref({
        handler: 0
    });

    painelMudouTema = ref({
        handler: 0
    });

    painelTeveAlteracao = ref({
        imediato: false,
        handler: 0
    });

    requisitaToggleMenu = ref({
        handler: 0,
        open: false
    });

    novoObjetoDestinoChange = ref({
        destino: '',
        id: '',
        idFonteDados: '',
        handler: 0,
    });

    handleExecucaoPainel = ref(0);

    painel = ref({
        id: 'painel-container', //se mudar aqui, tem que mudar no css do VisPainel.vue //o painel REAL é a div com a classe ".painel" dentro disso
        editor: true,
        isSnapshot: false,
        isAgendamento: false,
        limparFiltros: false,
        state: {
            focused: false,
            executandoPrimeiraVez: true,
        },

        tamanho: {
            original: null,
            atual: null,
        },

        tamanhoTablet: {
            original: null,
            atual: null,
        },
        tamanhoWidget: {
            original: null,
            atual: null,
        },

        tamanhoMobile: {
            original: null,
            atual: null,
        },

        cores: [],

        modelosGridAtivos: [],

        altDinamicaMobile: {enabled: false, px: 0},
        altDinamicaTablet: {enabled: false, px: 0},
        altDinamicaDesktop: {enabled: false, px: 0},
        altDinamicaWidget: {enabled: false, px: 0},

        percAlturaDinamica() {
            if (!this.dadosPainel.alturaDinamica || !this.dadosPainel.alturaDinamicaMobile || !this.dadosPainel.alturaDinamicaTablet)
                return 100;

            return this.tamanho.atual.height * 100 / this.tamanho.original.height;
        },

        fonteDadosAtualizacaoAutomaticas: [],
        dadosPainel: {
            background: {corClara: '', corEscura: ''},
            layout: {type: 'desktop', text: 'Desktop'},
            alturaDinamica: false,
            alturaDinamicaMobile: false,
            alturaDinamicaTablet: false,
            isWidget: false
        },
        // dadosWidget: {
        //     nome: '',
        //     colunas: 1,
        //     miniaturaClara: '',
        //     miniaturaEscura: '',
        //     link: {
        //         ativo: false,
        //         idPainel: 0
        //     },
        //     previsualizarLarguraMinima: false,
        //     larguraMinima: undefined
        // },
        navDrawer: {

            propGrid: {
                hide() {
                    this.width = 10;
                    this.open = false;
                },

                show() {
                    this.width = 350;
                    this.open = true;
                },

                open: true,
                component: 'layers',
                width: 350 //number => px
            }
        },
        alturaScroll: {
            visivel: 0,
            total: 0
        },
        topScroll: 0,
        valoresVariaveis: [],
        buscandoValorVariavelusuario: false,
        _coordenadasMapaDB: null,
        coordenadasMapaDB($vistra: Object) {
            return new Promise((resolve, reject) => {
                if (!this._coordenadasMapaDB) {
                    this._coordenadasMapaDB = new IndexedDB({
                        vistra: $vistra,
                        nomeBanco: "vistraCoordenadasMapa",
                        versao: 1,
                        tabelaPadrao: "coordenada",
                        tabelas: [{
                            nome: "coordenada",
                            chave: "url",
                            //se alterar os campos tem que incrementar a versao
                            campos: [
                                {nome: "url", unico: true},
                                {nome: "dados", unico: false}
                            ]
                        }],
                        onsuccess: () => {
                            resolve(this._coordenadasMapaDB)
                        },
                        onerror: () => {
                            reject()
                        }
                    })
                }
            })
        },
        isWidget: false
    })

    //#endregion

    //#region V A R I A V E I S  F U N C O E S
    onContentResized = () => {
        return this.contentResized.value;
    }

    onPainelResized = () => {
        return this.painelResized.value;
    }

    onPainelResizedTablet = () => {
        return this.painelResizedTablet.value
    }

    onPainelResizedMobile = () => {
        return this.painelResizedMobile.value
    }

    onPainelResizedWidget = () => {
        return this.painelResizedWidget.value
    }

    onPainelTeveAlteracao = () => {
        return this.painelTeveAlteracao.value
    }

    onNovoObjetoDestinoChange = () => {
        return this.novoObjetoDestinoChange.value
    }

    onPainelCopyObjects = () => {
        return this.painelCopyObjects.value.handler
    }

    onPainelCutObjects = () => {
        return this.painelCutObjects.value.handler
    }

    onPainelCopyCutCancel = () => {
        return this.painelCopyCutCancelObjects.value.handler
    }

    //#endregion

    //#region M E T O D O S
    painelAlterado(imediato: any) {
        this.painelTeveAlteracao.value = {
            handler: Math.random(),
            imediato: imediato || false
        }
    }

    setAlturaScroll(payload: any) {
        this.painel.value.alturaScroll = payload
    }

    setTopScroll(payload: any) {
        this.painel.value.topScroll = payload
    }

    painelSetMudaTema() {
        this.painelMudouTema.value = Math.random();
    }

    updateHandleExecucaoPainel(){
        this.handleExecucaoPainel.value = Math.random()
    }

    setAtualizaDados(tabela: string){
        this.tabelaAtualizaFontesDados.value.handler = Math.random()
        this.tabelaAtualizaFontesDados.value.tabela = tabela
    }

    setExibirGaleriaObjetos(payload: any) {
        this.exibirGaleriaObjetos.value = payload
    }

    setLayout(payload: any) {
        this.painel.value.dadosPainel.layout = payload;
    }

    setaAlturaD(payload: any) {
        if (payload.layout === 'mobile') {
            this.painel.value.dadosPainel.alturaDinamicaMobile = payload.value
            this.painel.value.tamanhoMobile.atual.height = payload.height
        } else if (payload.layout === 'tablet') {
            this.painel.value.dadosPainel.alturaDinamicaTablet = payload.value
            this.painel.value.tamanhoTablet.atual.height = payload.height
        } else if (payload.layout === 'widget') {
            this.painel.value.dadosPainel.alturaDinamicaWidget = payload.value
            this.painel.value.tamanhoWidget.atual.height = payload.height
        } else if (payload.layout === 'desktop') {
            this.painel.value.dadosPainel.alturaDinamica = payload.value
            this.painel.value.tamanho.atual.height = payload.height
        }
    }

    contentResize(payload: any) {
        this.content.value.tamanho.atual = payload

        //evento
        this.contentResized.value = {
            tamanho: payload,
            handler: Math.random()
        };
    }

    painelResize(payload: any) {
        this.painel.value.tamanho = payload;
        //state.visBoxAtualizaBoundSelecionados();
        //evento
        this.painelResized.value = {
            tamanho: payload,
            handler: Math.random()
        }
    }

    painelResizeTablet(payload: any) {
        this.painel.value.tamanhoTablet = payload

        this.painelResizedTablet.value = {
            tamanho: payload,
            handler: Math.random()
        };
    }

    painelResizeWidget(payload: any) {
        this.painel.value.tamanhoWidget = payload

        this.painelResizedWidget.value = {
            tamanho: payload,
            handler: Math.random()
        };
    }

    painelResizeMobile(payload: any) {
        this.painel.value.tamanhoMobile = payload

        this.painelResizedMobile.value = {
            tamanho: payload,
            handler: Math.random()
        };
    }

    setRequisitaToggleMenu() {
        this.requisitaToggleMenu.value = {
            handler: Math.random(),
            open: !this.requisitaToggleMenu.value.open
        }
    }

    setAlturaDinamicaMobile(payload: any) {
        this.painel.value.altDinamicaMobile.px = payload.height
    }

    setAlturaDinamicaTablet(payload: any) {
        this.painel.value.altDinamicaTablet.px = payload.height
    }

    setAlturaDinamicaDesktop(payload: any) {
        this.painel.value.altDinamicaDesktop.px = payload.height
    }

    painelSetCutObjects() {
        this.painelCutObjects.value.handler = Math.random();
    }

    painelSetCopyObjects() {
        this.painelCopyObjects.value.handler = Math.random();
    }

    painelSetCopyCutCancel() {
        this.painelCopyCutCancelObjects.value.handler = Math.random();
    }

    carregarPaletas() {
        this._app.appContext.config.globalProperties.$http.get("/Paleta/CarregarPaletas")
            .then((response: any) => {
                this.paletasCores.value = response.data
                this.painel.value.cores = this.paletasCores.value.find(p => p.id)?.cores

                this.carregouDoBanco.value = true;
            })
            .catch((err: any) => console.log(err))
    }

    getCorPaleta(obj) {
                
        if (obj == undefined)
            return undefined;

        if (typeof obj == 'string')
        {
            if (obj.length)
                return obj;
            return undefined;
        }

        if (!Object.keys(obj).length)
            return undefined;
        this.painel.value.cores = this.paletasCores.value.find(p => p.id == obj.idPaleta)?.cores
        if (obj != undefined && this.paletasCores.value.length > 0){
            if (obj.id == undefined || obj.id == -1)
                return obj
            return this.paletasCores.value.find(p => p.id == obj.idPaleta)?.cores?.find(c => c.id == obj.id)
        }
    }

    setNovoObjetoDestinoChange(payload: any) {
        this.novoObjetoDestinoChange.value = {
            handler: Math.random(),
            destino: payload.destino,
            id: payload.id,
            idFonteDados: payload.idFonteDados,
        }
    }

    getFontesDeDados() {
        if (this.painel.value.dadosPainel == undefined || this.painel.value.dadosPainel.fontesDados == undefined)
            return null;

        let fonteDados = this.painel.value.dadosPainel.fontesDados.map((f:any) => {
            return {
                idUnico: f.idUnico,
                desc: f.alias,
                campos: f.campos,
                aux: undefined //para utilização livre em componentes //nao mexer, isso é utilizado!!
            }
        }).sort((a:any, b:any) => {
            //Ordena as fontes de dados por sua descrição
            if((a.alias || a.desc) > (b.alias || b.desc)) return 1;
            if((a.alias || a.desc) < (b.alias || b.desc)) return -1;
            return 0;
        });

        return fonteDados;
    }

    getFonteDeDados(idUnico:any) {
        if (this.painel.value.dadosPainel == undefined || this.painel.value.dadosPainel.fontesDados == undefined)
            return null;

        return this.painel.value.dadosPainel.fontesDados.find((f:any) => f.idUnico == idUnico);
    }

    async replaceVariaveisUsuario(texto:any) {
        if (texto) {
            let variaveis = texto.match(/\[(\d*)\|[^\[]*\]/gimu)
            if (variaveis) {
                await this._app.appContext.config.globalProperties.$vistra.Objetos.when2(
                    {
                        condition: () => !this.painel.value.buscandoValorVariavelusuario,
                        callback: async () => {
                            // let req = "!@#$ " + Math.random().toString().slice(2, 5)
                            this.painel.value.buscandoValorVariavelusuario = true;
                            for (let variavel of variaveis) {
                                let idVariavel = variavel.match(/\[(\d*)\|[^\[]*\]/)[1]
                                let valorVariavel =  this.painel.value.valoresVariaveis.find(v => v.id === idVariavel)
                                let valorBanco;
                                if (!valorVariavel) {
                                    // console.show(req, " - 1 - Buscando valor de variável de usuário", variavel)
                                    valorBanco = (await this._app.appContext.config.globalProperties.$http.get("/VariavelUsuario/GetValorVariavel/"+ idVariavel)).data
                                    valorVariavel = {
                                        id: idVariavel,
                                        valor: valorBanco
                                    }
                                    this.painel.value.valoresVariaveis.push(valorVariavel)
                                } else {
                                    // console.show(req, " - 2 - Reaproveitou valor de variável de usuário", variavel)
                                }
                                texto = texto.split(variavel).join(valorVariavel.valor)
                            }
                            this.painel.value.buscandoValorVariavelusuario = false;
                        },
                        interval: 2
                    }
                )
            }
        }
        return texto
    }

    transformaTextoComVariaveis({texto, variaveis, dados, tiraHtml}:any) {
        let formatacaoCondicional = (dados || { formatacaoCondicional: [] }).formatacaoCondicional || [];
        //console.trace();

        let resolveFormatacao = (variavel:any) => {
            if (!formatacaoCondicional.length)
                return undefined;

            let formatacoes = formatacaoCondicional.filter((f:any) => f.valor.variavel == variavel.nome);
            if (!formatacoes.length)
                return undefined;

            //prepara os dados das variavels pra serem queryáveis
            var dadosVariaveis = variaveis.map(v => ({ [v.nome]: v.valor }));

            let formatacaoRetorno = undefined;

            const processaCamposRelativosDBText = (arrayP:any, dadosP:any) => {
                let array = [...arrayP]
                array.forEach((element, index) => {
                    if(Array.isArray(element)){
                        array[index] = processaCamposRelativosDBText(element, dadosP);
                    } else if(index == 0 && element.match(new RegExp(`.*_relativo$`, 'g'))) {
                        array[0] = element.substring(0, element.length - "_relativo".length)
                        array[2] = (dadosP.find(d => d.hasOwnProperty(array[2])) || { [array[2]]: ''})[array[2]];
                    } else if(index == 0 && (element.match(new RegExp(`.*\.outroCampo`, 'g')) || element.match(new RegExp(`.*\.variavelDoCard`, 'g')) || element.match(new RegExp(`.*\.variavelDoPainel`, 'g')))) { //jeito novo
                        array[0] = element.split('.')[0]
                        array[2] = (dadosP.find(d => d.hasOwnProperty(array[2])) || { [array[2]]: ''})[array[2]];
                    } else if(index == 0 && !element.match(new RegExp(`.*_relativo$`, 'g')) && !element.match(new RegExp(`.*\.outroCampo`, 'g'))) {
                        array[0] = element
                    } else if(index == 2 && (element == 0 || element == '0')) {
                        array[2] = '0'
                    }
                });
                return array
            }

            formatacoes.forEach((f:any) => {
                let filtro = this._app.appContext.config.globalProperties.$vistra.modificaBetween(f.valor.filtroExec);
                var filteredData = Query(dadosVariaveis)
                    .filter(processaCamposRelativosDBText(filtro, dadosVariaveis))//.filter(filtro)
                    .toArray();

                if (filteredData.length)
                    formatacaoRetorno = f.valor;
            });

            return formatacaoRetorno;
        }

        let variaveisNoTexto = (texto || "").match(new RegExp(`%[^${String.fromCharCode(160)}${String.fromCharCode(32)}%\b\n]+%`, 'g')); //%[^  %\b\n]+%

        //console.log('FORMATACOES:', formatacaoCondicional)

        if(!!variaveisNoTexto && variaveis != undefined)
            variaveisNoTexto.forEach((variavelNoTexto:any) => {
                let variavel = variaveis.find((v:any) => `%${v.nome}%` == variavelNoTexto),
                    icone = undefined,
                    podeFormatar = true

                if(!!variavel) {
                    //console.show('VARRRRRRRR:', variavel.nome, '->', variavel)
                    //////criar o style
                    let styleVar = '';
                    let styleIco = '';
                    let tagIconeBefore = '';
                    let tagIconeAfter = '';
                    let textoPersonalizado = '';

                    //procura formatacao condicional pra variavel
                    let formatacao = resolveFormatacao(variavel);
                    let getValue = (prop:any, def:any = null) => {
                        let ret = this._app.appContext.config.globalProperties.$vistra.Components.getValue(formatacao, prop);
                        if (!!def && (ret == undefined))
                            ret = def;
                        return ret;
                    };

                    if (formatacao && variavel.valor !== "") {
                        //console.show('FFFFFF', formatacao)
                        textoPersonalizado = formatacao.textoPersonalizado;

                        //aplicar estilo de fonte
                        for (let estilo of (formatacao.aplicar || []).sort()) {
                            switch (estilo) {
                                case 'negrito':
                                    styleVar += 'font-weight:bold;';
                                    break;
                                case 'italico':
                                    styleVar += 'font-style:italic;';
                                    break;
                                case 'riscado':
                                case 'sublinhado':
                                    if (!styleVar.includes('text-decoration:'))
                                        styleVar += 'text-decoration:;'
                                    styleVar = styleVar.replace('text-decoration:', `text-decoration: ${(estilo == 'riscado' ? 'line-through' : '')}${estilo == 'sublinhado' ? 'underline' : ''}`);
                                    break;
                                default:
                                    console.show('DBTEXTO: Estilo de formatacao condicional não tratado');
                                    break;
                            }
                        }

                        //aplica cor de fonte
                        let cor = getValue('cores.corTexto.value');
                        if (cor)
                            styleVar += `color:${cor.id < 0 ? this._app.appContext.config.globalProperties.$vistra.Components.resolveCor(cor) : this._app.appContext.config.globalProperties.$vistra.Components.resolveCor(this.resolveFullCor(cor.idPaleta, cor.id))};`;

                        //aplicar cor de fundo
                        cor = getValue('cores.corFundo.value');
                        if (cor)
                            styleVar += `background:${cor.id < 0 ? this._app.appContext.config.globalProperties.$vistra.Components.resolveCor(cor) : this._app.appContext.config.globalProperties.$vistra.Components.resolveCor(this.resolveFullCor(cor.idPaleta, cor.id))};`;

                        //fonte
                        let fonte = getValue('fonte.value');
                        if (fonte) {
                            if (fonte.tipo)
                                styleVar += `font-family:'${fonte.tipo}';`;
                            if (fonte.tamanho)
                                styleVar += `font-size:${fonte.tamanho};`;
                        }

                        if (styleVar)
                            styleVar = ` style="${styleVar}"`;

                        //icone
                        icone = getValue('icone.value');
                        if (!!icone) {
                            if (icone && icone.constructor.name == 'String')
                                icone = { nome: icone };

                            if (!!icone.nome)
                            {
                                cor = getValue('cores.corIcone.value');
                                if (cor)
                                    styleIco += `color:${cor.id < 0 ? this._app.appContext.config.globalProperties.$vistra.Components.resolveCor(cor) : this._app.appContext.config.globalProperties.$vistra.Components.resolveCor(this.resolveFullCor(cor.idPaleta, cor.id))};`;

                                if (icone.tamanho != undefined) {
                                    styleIco += `font-size: ${icone.tamanho};`
                                }


                                let margin = '';

                                if (!getValue('exibirTexto', true)) {
                                    icone.posicao = icone.posicao = undefined;
                                    margin = 'margin-left:5px!important;margin-right:5px!important;'
                                }

                                switch (icone.posicao) {
                                    case undefined:
                                        margin = 'margin-right:5px!important;'
                                        break;
                                    case 'direita':
                                        margin = 'margin-left:5px!important;'
                                        break;
                                    default:
                                        break;
                                }

                                styleIco = ` style="${margin}${styleIco}"`;

                                switch (icone.posicao) {
                                    case 'topo':
                                        tagIconeBefore = `<i class="${icone.nome}"${styleIco}></i><BR />`;
                                        if (icone.alinhamento)
                                            tagIconeBefore = `<span style="width:100%;display:block;text-align:${icone.alinhamento};">${tagIconeBefore}</span>`;
                                        break;
                                    case 'direita':
                                        tagIconeAfter = `<i class="${icone.nome}"${styleIco}></i>`;
                                        break;
                                    case 'baixo':
                                        tagIconeAfter = `<BR /><i class="${icone.nome}"${styleIco}></i>`;
                                        if (icone.alinhamento)
                                            tagIconeBefore = `<span style="width:100%;display:block;text-align:${icone.alinhamento};">${tagIconeBefore}</span>`;
                                        break;
                                    default:
                                        tagIconeBefore = `<i class="${icone.nome}"${styleIco}></i>`;
                                        break;
                                }
                            }
                        }
                    }

                    let valor = variavel.valorFormatado != undefined ? variavel.valorFormatado : variavel.valor
                    valor = Array.isArray(valor) ? valor.join(', ') : valor;
                    if (textoPersonalizado)
                        valor = textoPersonalizado.split('{v}').join(valor);
                    if (typeof valor === 'string')
                        valor = valor.split('<').join('&lt;').split('>').join('&gt;')
                    if (styleVar)
                        valor = `<span${styleVar}>${valor}</span>`;

                    if (icone && icone.nome && !getValue('exibirTexto', true))
                        valor = '';

                    if (styleVar || tagIconeBefore || tagIconeAfter)
                        texto = texto.replace(variavelNoTexto, `<span class="variavel">${tagIconeBefore}${valor}${tagIconeAfter}</span>`);
                    else //se não tem nenhuma formatação, deixa somente o texto pq pode ser url de imagem
                        texto = texto.replace(variavelNoTexto, valor);
                }
            });

        if(tiraHtml)
            return this._app.appContext.config.globalProperties.$vistra.decodeHTML(texto)

        if(tiraHtml)
            return this._app.appContext.config.globalProperties.$vistra.decodeHTML(texto)
        return texto
    }

    resolveFullCor(idPaleta:any, idCor:any) {
        let paleta = this.paletasCores.value.find((p:any) => p.id == idPaleta);
        if (!paleta)
            return undefined;
        return paleta.cores.find((c:any) => c.id == idCor);
    }


    //#endregion

}